import { Chip } from '@vnetwork/ui/primitives';
import { StatusPill } from '@vnetwork/ui/data';
import type { InvoiceDetail } from '@/api/invoices';
import {
  invoiceStatusTone,
  invoiceStatusLabel,
  invoiceTypeLabel,
  invoiceSaleTypeLabel,
  resolveSaleType,
} from '@/pages/invoices/invoice-format';
import { DetailHeader } from '@/components/detail-header';
import { InvoiceActions } from './invoice-actions';

/**
 * Invoice detail identity header — canonical `DetailHeader`: breadcrumb to the
 * list, the `invoice_code` as title, the status StatusPill (dominant) plus subtle
 * type / sale-type Chips as meta, and status-gated lifecycle actions.
 */
export function InvoiceDetailHeader({ id, detail }: { id: number; detail: InvoiceDetail }) {
  const title = detail.invoice_code || `#${detail.invoice_id}`;
  return (
    <DetailHeader
      parent={{ label: 'Invoices', to: '/invoices' }}
      current={title}
      title={title}
      meta={
        <>
          <StatusPill tone={invoiceStatusTone(detail.invoice_status)}>
            {invoiceStatusLabel(detail.invoice_status)}
          </StatusPill>
          <Chip appearance="subtle" tone="neutral" size="sm">
            {invoiceTypeLabel(detail.invoice_type)}
          </Chip>
          {resolveSaleType(detail.invoice_sale_type) ? (
            <Chip appearance="outline" tone="neutral" size="sm">
              {invoiceSaleTypeLabel(detail.invoice_sale_type)}
            </Chip>
          ) : null}
        </>
      }
      actions={<InvoiceActions id={id} detail={detail} />}
    />
  );
}
